import { TeButton, TeContainerSlim } from '@topcon/tuicl-react';
import { ChangeEvent, useRef } from 'react';
import { styled } from 'styled-components';

interface Props {
  disabled: boolean;
  onButtonClick: (event: ChangeEvent<HTMLInputElement>) => void;
  text: string;
  accept: string;
  multiple?: boolean;
  icon?: string;
}

const UploadButton = ({ disabled, onButtonClick, text, accept, multiple = false, icon }: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const openUploadDialog = () => {
    if (!inputRef.current) return;
    inputRef.current.click();
  };

  return (
    <TeContainerSlim>
      <HiddenInput
        ref={inputRef}
        type="file"
        value={''}
        disabled={disabled}
        onChange={onButtonClick}
        accept={accept}
        multiple={multiple}
      />
      <TeButton
        text={text}
        size="s"
        variant="neutral"
        teclick={openUploadDialog}
        disabled={disabled}
        icon={icon}
      />
    </TeContainerSlim>
  );
};

const HiddenInput = styled.input`
  display: none;
`;

export default UploadButton;
